import { useContext } from 'react';

import { NextSeo } from 'next-seo';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { LoadingSpinner } from '@/components/Atoms/LoadingSpinner/LoadingSpinner';
import { RegisterForm } from '@/components/Organisms/RegisterForm/RegisterForm';
import { LocalesContext } from '@/context/locales/LocalesProvider';
import UserContext from '@/context/user';
import { AuthPage } from '@/templates/AuthPage';
import { classMerge } from '@/utils/class-names';
import { makeLinkAbsolute } from '@/utils/Slug';
import { Routes } from 'data/Routes';
import { LocaleContext } from 'types/Locales';

const Title = ({ locales }: LocaleContext) => (
	<h1 className="mb-4 font-display text-display-3 font-bold uppercase">
		{locales['get-started']}
	</h1>
);

const Login = ({ locales }: LocaleContext) => (
	<div
		className={classMerge(
			'block font-body text-body-2',
			'font-medium text-neutral-grey-90'
		)}
	>
		<span className="mr-1">{locales['already-have-account']}</span>
		<Link href={Routes.login} as={makeLinkAbsolute(Routes.login)}>
			<a className="text-link-2 font-bold text-neutral-grey hover:underline">
				{locales['log-in']}
			</a>
		</Link>
	</div>
);

const Description = ({ locales }: LocaleContext) => (
	<>
		<p className="font-body text-body-2 font-medium text-neutral-grey">
			{locales['login-description']}
		</p>

		<Link
			href={Routes.privacyPolicy}
			as={makeLinkAbsolute(Routes.privacyPolicy)}
		>
			<a className="mt-5 font-body text-link-2 font-bold">
				{locales['learn-why']}
			</a>
		</Link>
	</>
);

const Register = () => {
	const { locales } = useContext(LocalesContext);
	const { user } = useContext(UserContext);
	const { push } = useRouter();

	if (user) {
		push(Routes.index);
	}

	if (user) {
		return (
			<div className="flex justify-center items-center w-full text-neutral-black">
				<LoadingSpinner width="2.75em" height="2.75em" />
			</div>
		);
	}

	return (
		<AuthPage className="space-y-5">
			<NextSeo />
			<Title locales={locales} />
			<Description locales={locales} />
			<RegisterForm />
			<Login locales={locales} />
		</AuthPage>
	);
};

export default Register;
